import log from 'salvo-lite/log'
import Rellax from 'rellax'

class Parallax {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            speed: -50,
            center: true,
            round: false,
            vertical: true,
            horizontal: false,
            percentage: 1
        }, JSON.parse(this.elem.dataset.parallax ? this.elem.dataset.parallax : '{}'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)
        Rellax(this.elem, this.options)
        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default Parallax



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Parallax.js